/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceChallengeZoneObjective
 */
export interface SurfaceChallengeZoneObjective {
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneObjective
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneObjective
     */
    sublabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneObjective
     */
    tag?: SurfaceChallengeZoneObjectiveTagEnum;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneObjective
     */
    state: SurfaceChallengeZoneObjectiveStateEnum;
}


/**
 * @export
 */
export const SurfaceChallengeZoneObjectiveTagEnum = {
    BRAND: 'BRAND',
    GAME: 'GAME',
    REWARD: 'REWARD'
} as const;
export type SurfaceChallengeZoneObjectiveTagEnum = typeof SurfaceChallengeZoneObjectiveTagEnum[keyof typeof SurfaceChallengeZoneObjectiveTagEnum];

/**
 * @export
 */
export const SurfaceChallengeZoneObjectiveStateEnum = {
    unchecked: 'unchecked',
    partial: 'partial',
    done: 'done'
} as const;
export type SurfaceChallengeZoneObjectiveStateEnum = typeof SurfaceChallengeZoneObjectiveStateEnum[keyof typeof SurfaceChallengeZoneObjectiveStateEnum];


/**
 * Check if a given object implements the SurfaceChallengeZoneObjective interface.
 */
export function instanceOfSurfaceChallengeZoneObjective(value: object): value is SurfaceChallengeZoneObjective {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    return true;
}

export function SurfaceChallengeZoneObjectiveFromJSON(json: any): SurfaceChallengeZoneObjective {
    return SurfaceChallengeZoneObjectiveFromJSONTyped(json, false);
}

export function SurfaceChallengeZoneObjectiveFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceChallengeZoneObjective {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'sublabel': json['sublabel'] == null ? undefined : json['sublabel'],
        'tag': json['tag'] == null ? undefined : json['tag'],
        'state': json['state'],
    };
}

export function SurfaceChallengeZoneObjectiveToJSON(json: any): SurfaceChallengeZoneObjective {
    return SurfaceChallengeZoneObjectiveToJSONTyped(json, false);
}

export function SurfaceChallengeZoneObjectiveToJSONTyped(value?: SurfaceChallengeZoneObjective | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'sublabel': value['sublabel'],
        'tag': value['tag'],
        'state': value['state'],
    };
}

